import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/system';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

import Loader from 'src/components/ui/Loader';
import useConfig from 'src/hooks/useConfig';
import { MenuOrientation } from 'src/config';
import { CALL_STICKER_HEIGHT } from 'src/components/ui/CallSticky/constants';
import useInterface from 'src/hooks/useInterface';

import sx from './styled/sx';

const DashboardLayout = (props) => {
	const {
		isLoading,
		children,
		innerAside,
		DashboardFooterRP,
		BreadcrumbsRP,
		HeaderRP,
		MainDrawerRP,
		HorizontalBarRP,
		CallStickyRP,
	} = props;
	const { isStickCall } = useInterface();
	const { container, menuOrientation } = useConfig();
	const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
	const downMD = useMediaQuery((theme) => theme.breakpoints.down('md'));
	const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	const MenuComp = isHorizontal ? HorizontalBarRP : MainDrawerRP;

	if (isLoading) return <Loader />;

	const hasStickyCall = isStickCall && CallStickyRP;

	return (
		<Box sx={{ display: 'flex', width: '100%' }}>
			{HeaderRP && <HeaderRP />}
			{MenuComp && <MenuComp />}
			<Box component="main" sx={sx.mainBox()}>
				<Box
					sx={{
						height: hasStickyCall ? CALL_STICKER_HEIGHT : 0,
						transition: '.2s height',
					}}
				/>
				{hasStickyCall && <CallStickyRP />}
				{HeaderRP && <Toolbar sx={{ mt: isHorizontal ? 8 : 'inherit' }} />}
				<Box sx={sx.wrap()}>
					{innerAside && (
						<>
							{downMD ? (
								<Drawer>{innerAside}</Drawer>
							) : (
								<Box sx={sx.innerAside()}>{innerAside}</Box>
							)}
						</>
					)}
					<Container
						maxWidth={container ? 'md' : false}
						sx={sx.container({ container })}
					>
						{BreadcrumbsRP && <BreadcrumbsRP />}
						{children}
						{DashboardFooterRP && <DashboardFooterRP />}
					</Container>
				</Box>
			</Box>
		</Box>
	);
};

DashboardLayout.propTypes = {
	isLoading: PropTypes.bool,
	innerAside: PropTypes.node,
	children: PropTypes.node,
	DashboardFooterRP: PropTypes.elementType,
	BreadcrumbsRP: PropTypes.elementType,
	HeaderRP: PropTypes.elementType,
	MainDrawerRP: PropTypes.elementType,
	HorizontalBarRP: PropTypes.elementType,
	CallStickyRP: PropTypes.elementType,
};

export default DashboardLayout;
